import styled from 'styled-components';

export const Wrapper = styled.div<{ isDesktop?: boolean }>`
  display: flex;
  cursor: pointer;
  max-width: ${({ isDesktop }) => (isDesktop ? '240px' : '100%')};

  & a {
    text-decoration: none !important;
  }
`;
export const Item = styled.span<{ isColor?: boolean }>`
  margin-left: 5px;
  font-size: 18px;
  cursor: pointer;
  color: ${({ isColor, theme }) =>
    isColor ? theme.palette.coral : theme.palette.black};
  font-weight: ${({ isColor }) => (isColor ? 'bold' : '400')};
  :hover {
    color: ${({ theme }) => theme.palette.coral};
  }
`;
export const SidebarContainer = styled.div<{ isDesktop?: boolean }>`
  padding: 8px;
  display: block;
  border-radius: 5px;
  width: 100%;
`;
export const ParentSidebar = styled.div<{ isDesktop?: boolean }>`
  padding-left: 8px;
  display: block;
  border-radius: 5px;
  min-height: 64px;
  height: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;
export const SidebarContent = styled.div<{ open?: boolean }>`
  height: ${({ open }) => (open ? 'auto' : '0')};
  overflow: hidden;
`;
export const ItemContainer = styled.div<{ isParent?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin: ${({ isParent }) =>
    isParent ? '10px 10px 20px 10px' : '5px 5px 17px 10px'};
  :hover {
    && span {
      color: ${(p) => p.theme.palette.coral};
    }
  }
`;
export const Title = styled.span<{ isColor?: boolean }>`
  font-size: 18px;
  margin-left: 5px;
  color: ${({ isColor, theme }) =>
    isColor ? theme.palette.coral : theme.palette.black};
`;
export const TitleWrapper = styled.div`
  display: flex;
`;
export const ChildTitleWrapper = styled.div`
  display: flex;
  padding-left: 16px;
`;
export const Container = styled.div`
  display: flex;
`;
export const Separate = styled.div<{ isColor?: boolean; isParent?: boolean }>`
  display: block;
  border: 0;
  height: 10px;
  margin-top: ${({ isParent }) => (isParent ? '10px' : '0')};
  border-top: 1px solid
    ${({ theme, isColor }) =>
      isColor ? theme.palette.coral : theme.palette.gray87};
  min-width: 240px;
  margin-bottom: -5px;
`;
export const ChildContainer = styled.div`
  padding-left: 5px;
`;
export const Text = styled.span<{ isColor?: boolean }>`
  font-size: 18px;
  margin-left: 5px;
  cursor: pointer;
  color: ${({ isColor, theme }) =>
    isColor ? theme.palette.coral : theme.palette.black};
  font-weight: ${({ isColor }) => (isColor ? 'bold' : '400')};
  :hover {
    color: ${({ theme }) => theme.palette.coral};
  }
`;
export const SideBarChild = styled.div<{ isDesktop?: boolean }>`
  display: block;
  width: ${({ isDesktop }) => (isDesktop ? 'auto' : '100%')};
`;
